import { palette } from '../../Palette';
function getMainColor(localPallete) {
    const primary = localPallete.primary;
    if (!primary) {
        return '';
    }
    if (primary.main) {
        return primary.main;
    }
    return '';
}
const MuiOutlinedInput = {
    styleOverrides: {
        root: {
            '&.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: getMainColor(palette),
                    borderWidth: 1,
                },
            },
        },
    },
};
export default MuiOutlinedInput;
//# sourceMappingURL=MuiOutlinedInput.js.map